// Month helpers shared by the Revenue Goals pages. Months are 'YYYY-MM'
// strings end to end (API + Set Targets grid + board picker).

const pad = (n) => String(n).padStart(2, '0')

const monthKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`

// The month we are standing in. Revenue Goals is a worklist, not a plan:
// the team opens it to see who to call TODAY, and every activity signal
// underneath it (wallet usage, attendance, instalments) is measured against
// the month being viewed — so opening on a future month showed empty lanes
// until that month had happened (Shruti, 2026-07-24).
export const currentMonth = () => {
  const d = new Date()
  d.setDate(1)
  return monthKey(d)
}

// Planning happens for the COMING month, so that's the default.
export const defaultPlanningMonth = () => {
  const d = new Date()
  d.setDate(1)
  d.setMonth(d.getMonth() + 1)
  return monthKey(d)
}

// The next `count` months starting from the coming month — the Set
// Targets grid columns (planning is always forward-looking).
export const planningMonths = (count = 3) => {
  const out = []
  const d = new Date()
  d.setDate(1)
  d.setMonth(d.getMonth() + 1)
  for (let i = 0; i < count; i += 1) {
    out.push(monthKey(d))
    d.setMonth(d.getMonth() + 1)
  }
  return out
}

export const monthShort = (month) => {
  if (!month) return '—'
  const [y, m] = month.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', {
    month: 'short',
    year: '2-digit'
  })
}

// Current month + the next `count - 1` — the picker's option list.
// `count` months forward from the current month, plus `back` months before it.
// Default back=0 preserves the original forward-only behaviour for existing
// callers (planning/targets); the worklist + reports pass back to look at past
// months (user 2026-07-31). Returned oldest → newest.
export const monthOptions = (count = 4, back = 0) => {
  const out = []
  const d = new Date()
  d.setDate(1)
  d.setMonth(d.getMonth() - back)
  for (let i = 0; i < count + back; i += 1) {
    out.push(monthKey(d))
    d.setMonth(d.getMonth() + 1)
  }
  return out
}

export const monthLabel = (month) => {
  if (!month) return '—'
  const [y, m] = month.split('-').map(Number)
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', {
    month: 'long',
    year: 'numeric'
  })
}

// An ISO date ('2026-07-01') as a human date — "1 July 2026". Returns '—'
// for empty/invalid input.
export const dayMonthYear = (iso) => {
  if (!iso) return '—'
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return '—'
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export const inr = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value)))
    return '—'
  return `₹${Number(value).toLocaleString('en-IN', {
    maximumFractionDigits: 0
  })}`
}
